import { c as _c } from "react/compiler-runtime";
import { FormControl, FormLabel } from '@mui/material';
import type { Account } from '@repo/api-gw-sdk';
import { useState } from 'react';
import type { BackupVault } from '@/data/vaults/backupVault';
import { SelectVaultBucketPanel } from './selectVaultBucketPanel';
import { ChangeableTextField } from '../text/changeableTextField';
export const VaultAccountBucketSelector = t0 => {
  const $ = _c(15);
  const {
    data,
    setData,
    vaultAccounts
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FormLabel>{"Vault account and bucket"}</FormLabel>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = !data.region;
  const t3 = data.vaultAttributes.aws?.bucketName;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setOpen(true);
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t2 || $[3] !== t3) {
    t5 = <ChangeableTextField disabled={t2} value={t3} onClick={t4} placeholder="None selected" />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = open && !!data.region;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setOpen(false);
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const t8 = !data.region;
  let t9;
  if ($[6] !== data || $[7] !== setData || $[8] !== t6 || $[9] !== t8 || $[10] !== vaultAccounts) {
    t9 = <SelectVaultBucketPanel open={t6} onClose={t7} disabled={t8} data={data} setData={setData} vaultAccounts={vaultAccounts} />;
    $[6] = data;
    $[7] = setData;
    $[8] = t6;
    $[9] = t8;
    $[10] = vaultAccounts;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t5 || $[13] !== t9) {
    t10 = <FormControl size="small" className="flex-1">{t1}{t5}{t9}</FormControl>;
    $[12] = t5;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
};